/* =====================================================================
   Bolden policy pages: adds a section list, effective-date header and
   section numbering to Shopify's policy markup. The policy text itself
   is never changed; it is only rearranged on screen.
   ===================================================================== */
(function () {
  'use strict';

  function slugify(text) {
    return text.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  var SMALL_WORDS = /^(a|an|and|as|at|but|by|for|in|of|on|or|the|to|with)$/;
  function fixAllCaps(text) {
    if (text.length < 4 || text !== text.toUpperCase() || !/[A-Z]/.test(text)) return text;
    return text.toLowerCase().split(' ').map(function (w, i) {
      if (i > 0 && SMALL_WORDS.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  // Some pages use bold lines ("<strong>Use of Personal Information</strong>")
  // instead of real headings. Turn those lines into headings so they can be
  // listed and linked. The wording is unchanged.
  function promoteBoldLabels(root, level) {
    var paragraphs = Array.prototype.slice.call(root.querySelectorAll('p'));
    paragraphs.forEach(function (p) {
      var nodes = Array.prototype.filter.call(p.childNodes, function (n) {
        return !(n.nodeType === 3 && !n.textContent.trim());
      });
      if (!nodes.length) return;
      var first = nodes[0];
      if (first.nodeType !== 1) return;
      var boldEl = first;
      if (!/^(STRONG|B)$/.test(boldEl.tagName)) {
        boldEl = first.querySelector && first.querySelector('strong, b');
        if (!boldEl || boldEl.textContent.trim() !== first.textContent.trim()) return;
      }
      var label = boldEl.textContent.replace(/\s+/g, ' ').trim();
      if (label.length < 3 || label.length > 70 || /[:.,;]$/.test(label)) return;
      var second = nodes[1];
      if (second && !(second.nodeType === 1 && second.tagName === 'BR')) return;

      var heading = document.createElement(level);
      heading.textContent = label;
      p.parentNode.insertBefore(heading, p);
      first.remove();
      if (second) second.remove();
      if (!p.textContent.trim() && !p.querySelector('img')) p.remove();
    });
  }

  function init() {
    var container = document.querySelector('.shopify-policy__container');
    var title = container && container.querySelector('.shopify-policy__title');
    var body = container && container.querySelector('.shopify-policy__body');
    if (!container || !title || !body) return;

    var pageTitle = (title.textContent || '').trim().toLowerCase();

    // 1. Hide a repeated title at the top of the policy text
    var firstH1 = body.querySelector('h1');
    if (firstH1 && firstH1.textContent.trim().toLowerCase() === pageTitle) {
      firstH1.classList.add('policy-duplicate-title');
    }

    // 2. Move the "Effective Date" line up under the page title
    var meta = document.createElement('div');
    meta.className = 'policy-meta';
    var paragraphs = body.querySelectorAll('p');
    for (var i = 0; i < paragraphs.length; i++) {
      if (/^\s*(effective date|last updated)/i.test(paragraphs[i].textContent)) {
        var dateLine = document.createElement('span');
        dateLine.innerHTML = paragraphs[i].innerHTML;
        meta.appendChild(dateLine);
        paragraphs[i].remove();
        break;
      }
    }
    var contactLink = document.createElement('span');
    contactLink.innerHTML = 'Questions? <a href="/pages/contact">Contact us</a>';
    meta.appendChild(contactLink);
    title.appendChild(meta);

    // 3. Find the sections. Pages without real headings get their bold
    //    labels promoted; pages with only a couple of h2s list h3s too.
    var h2Count = body.querySelectorAll('h2').length;
    promoteBoldLabels(body, h2Count ? 'h3' : 'h2');
    var useSubheads = body.querySelectorAll('h2').length < 4;
    var headings = body.querySelectorAll(useSubheads ? 'h2, h3' : 'h2');
    if (!headings.length) return;
    var tocItems = [];
    var usedIds = {};

    headings.forEach(function (h) {
      var text = fixAllCaps(h.textContent.replace(/\s+/g, ' ').trim());
      if (text !== h.textContent.trim()) h.textContent = text;
      var match = text.match(/^(\d+)\.\s*(.+)$/);
      var num = match ? match[1] : '';
      var label = match ? match[2] : text;

      var id = h.id || slugify(label) || 'section';
      while (usedIds[id]) id += '-x';
      usedIds[id] = true;
      h.id = id;

      if (num) {
        h.innerHTML = '<span class="policy-num" aria-hidden="true">' + num + '.</span><span><span class="visually-hidden">' + num + '. </span>' + label + '</span>';
      }
      tocItems.push({ id: id, num: num, label: label, el: h, sub: h.tagName === 'H3' });
    });

    // 4. Contact section gets a tinted card
    var last = tocItems[tocItems.length - 1];
    if (last && /contact/i.test(last.label)) {
      var card = document.createElement('div');
      card.className = 'policy-contact';
      var node = last.el.nextSibling;
      while (node) {
        var next = node.nextSibling;
        card.appendChild(node);
        node = next;
      }
      last.el.parentNode.appendChild(card);
    }

    // 5. Section list (sticky sidebar on desktop, collapsible on mobile)
    var nav = document.createElement('nav');
    nav.className = 'policy-toc';
    nav.setAttribute('aria-label', 'On this page');
    var listHtml = tocItems.map(function (item) {
      return '<li' + (item.sub ? ' class="policy-toc__sub"' : '') + '><a href="#' + item.id + '">' +
        (item.num ? '<span class="policy-toc__num">' + item.num + '.</span>' : '<span class="policy-toc__num"></span>') +
        '<span>' + item.label + '</span></a></li>';
    }).join('');
    nav.innerHTML = '<details><summary>On this page</summary><ol>' + listHtml + '</ol></details>';

    var desktop = window.matchMedia('(min-width: 992px)');
    var details = nav.querySelector('details');
    var syncOpen = function () { details.open = desktop.matches; };
    syncOpen();
    if (desktop.addEventListener) desktop.addEventListener('change', syncOpen);

    // Close the mobile list after choosing a section
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a') && !desktop.matches) details.open = false;
    });

    var layout = document.createElement('div');
    layout.className = 'policy-layout';
    body.parentNode.insertBefore(layout, body);
    layout.appendChild(nav);
    layout.appendChild(body);

    // 6. Back to top
    var top = document.createElement('a');
    top.href = '#';
    top.className = 'policy-top-link';
    top.textContent = 'Back to top';
    top.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      title.setAttribute('tabindex', '-1');
      title.focus({ preventScroll: true });
    });
    body.appendChild(top);

    // 7. Highlight the section currently on screen
    if ('IntersectionObserver' in window) {
      var links = {};
      nav.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
      var current = null;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (current) current.removeAttribute('aria-current');
          current = links[entry.target.id];
          if (current) current.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '0px 0px -75% 0px' });
      tocItems.forEach(function (item) { observer.observe(item.el); });
    }
  }

  function run() {
    try { init(); }
    finally { document.documentElement.classList.remove('policy-enhancing'); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
